import React from 'react';

const ZEDIT_LOGO = 'https://cdn.prod.website-files.com/66b15405a40d08308c5003c9/66e03da21d1cb84078dc8218_logo%20design.png';

const ZeditLogo = ({ className = '', theme = 'light' }) => {
  const isDark = theme === 'dark';
  return (
    <div className={`flex items-center ${className}`} data-testid="zedit-logo">
      <img
        src={ZEDIT_LOGO}
        alt="Zedit"
        className={`h-8 sm:h-9 w-auto object-contain ${isDark ? 'brightness-0 invert' : ''}`}
        loading="eager"
      />
    </div>
  );
};

export default ZeditLogo;
